import React, { useEffect, useState } from "react";
import "./Layout.scss";
import { Button, Result } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setNetworkDrop } from "store/slice/login-slice";
import Loader from "Components/Loader";
import { Layout } from "antd";
import {
  NiyamaLogoText,
  NiyamaTestLogoText,
  NiyamaNewLogo,
  NiyamaStgLogoText,
} from "Common/ReactIcons";
import { NETWORK_BACK_MSG } from "Common/constant";
import { SOMETHING_WRONG_MSG } from "Common/constant";
import { OFFLINE_MSG } from "Common/constant";
import { CHECK_NETWORK_MSG, ORG_ID } from "Common/constant";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user_details = useSelector((state) => state.loginReducer.user_details);

  const { Header } = Layout;
  const [isNetworkBack, setIsNetworkBack] = useState(false);
  const [Logo, isSetLogo] = useState("");
  const [colorTheme, isSetColorTheme] = useState(true);

  const handleGoBack = () => {
    resetErrorBoundary();
    history.goBack();
  };

  const handleRetry = () => {
    window.location.reload();
  };

  const handleNetworkBack = () => {
    dispatch(setNetworkDrop(false));
    setIsNetworkBack(true);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const partnerLogo = () =>{
    let org_id = user_details?.org_name || (user_details?.role === "Guest" && window.location.host) || "default";
    let logo = ORG_ID[org_id] ? ORG_ID[org_id]  :  ORG_ID["default"];
    isSetLogo(logo.full_logo)
    isSetColorTheme(false)
  }

  useEffect(() => {
    if(colorTheme || (Logo != (user_details?.org_name || (user_details?.role === "Guest" && window.location.host) || "default"))){
      partnerLogo()
    }
    window.addEventListener("online", handleNetworkBack);
    return () => {
      window.removeEventListener("online", handleNetworkBack);
    };
  }, []);

  return (
    <>
      <Header className="header-layout" id="header">
        <div className="logo-container">
          {process.env.REACT_APP_ENV == "dev" ? (
            <img src={Logo} />
            // <NiyamaNewLogo className="main-logo" />
          ) : process.env.REACT_APP_ENV == "test" ? (
            <NiyamaTestLogoText className="main-logo" />
          ) : process.env.REACT_APP_ENV == "staging" ? (
            <NiyamaStgLogoText className="main-logo" />
          ) : (
            <NiyamaLogoText className="main-logo" />
          )}
        </div>
      </Header>
      {isNetworkBack ? (
        <Result
          icon={<Loader />}
          subTitle={<span className="netwk-bck-msg">{NETWORK_BACK_MSG}</span>}
        />
      ) : (
        <Result
          status={navigator.onLine ? "500" : "error"}
          title={
            <div>
              <span className="chk-netwk_title">
                {navigator.onLine ? SOMETHING_WRONG_MSG : OFFLINE_MSG}
              </span>
            </div>
          }
          subTitle={
            <div>
              {!navigator.onLine && (
                <span className="chk-netwk_msg">{CHECK_NETWORK_MSG}</span>
              )}
            </div>
          }
          extra={
            <div className="error-boundary-container">
              {navigator.onLine ? (
                <Button
                  className="error-boundary-button"
                  onClick={handleGoBack}
                >
                  Go Back
                </Button>
              ) : (
                <Button className="error-boundary-button" onClick={handleRetry}>
                  Retry
                </Button>
              )}
            </div>
          }
        />
      )}
    </>
  );
};

export default ErrorFallback;
